import { render, staticRenderFns } from "./OutboundAndInboundRoutingContent.vue?vue&type=template&id=6770f022&"
import script from "./OutboundAndInboundRoutingContent.vue?vue&type=script&lang=js&"
export * from "./OutboundAndInboundRoutingContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports